import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";

const ManufacturerCodeDeleteDialog = ({
  open,
  manufacturerCode,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth>
      <DialogContent>
        <Typography variant="h6" color="primary">
          Confirm Delete
        </Typography>

        <Divider style={{ marginTop: "16px", marginBottom: "16px" }} />

        <Typography>
          Are you sure you want to delete manufacturer code{" "}
          <strong>{manufacturerCode}</strong>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>

        <Button color="secondary" variant="contained" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManufacturerCodeDeleteDialog;
